import React, { useState, useEffect, useRef } from "react";
import { Avatar, CircularProgress } from "@material-ui/core";

const imageQueue = [];
let isProcessingQueue = false;

const processQueue = () => {
  if (imageQueue.length === 0) {
    isProcessingQueue = false;
    return;
  }

  isProcessingQueue = true;
  const nextImage = imageQueue.shift();
  nextImage();

  setTimeout(processQueue, 1000);
};

const UserAvatar = ({ user }) => {
  const [avatarSrc, setAvatarSrc] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(true);
  const hasQueued = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    hasQueued.current = false;

    const loadImage = () => {
      if (!isMounted.current) return;

      const imageUrl = `/4DACTION/IMAGE_PROFILE/?person=${
        user.ID
      }&alea=${Math.floor(Math.random() * 1000000)}`;

      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          if (isMounted.current) {
            const url = URL.createObjectURL(blob);
            setAvatarSrc(url);
            setIsLoading(false);
          }
        })
        .catch(() => {
          if (isMounted.current) {
            setIsLoading(false);
          }
        });
    };

    if (!hasQueued.current) {
      imageQueue.push(loadImage);
      hasQueued.current = true;

      if (!isProcessingQueue) {
        processQueue();
      }
    }

    return () => {
      isMounted.current = false;

      const index = imageQueue.indexOf(loadImage);
      if (index > -1) {
        imageQueue.splice(index, 1);
      }

      if (avatarSrc) {
        URL.revokeObjectURL(avatarSrc);
      }
    };
  }, [user.ID, avatarSrc]);

  if (isLoading) {
    return (
      <Avatar style={{ width: 100, height: 100 }}>
        <CircularProgress />
      </Avatar>
    );
  }

  return (
    <Avatar
      src={avatarSrc}
      style={{
        width: 100,
        height: 100,
      }}
    >
      {user.Name ? user.Name[0].toUpperCase() : "?"}
    </Avatar>
  );
};

export default UserAvatar;
